import Ajax from "Utils/ajax";
export const teamUserList = (data) => Ajax.post('hr/teamUserList',data); 